declare global {
  interface Window {
    dataLayer: IArguments[]
    gtag: {
      (command: 'js', date: Date): void
      (command: 'config', targetId: string, config?: Record<string, unknown>): void
      (command: 'event', eventName: string, params?: Record<string, unknown>): void
    }
  }
}

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export function initGtag() {
  if (!GA_ID) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    // biome-ignore lint/complexity/noArguments: gtag API requires the arguments object
    window.dataLayer.push(arguments)
  } as unknown as Window['gtag']
  window.gtag('js', new Date())
  window.gtag('config', GA_ID, { send_page_view: false })
}

export function trackPageView(path: string) {
  if (!window.gtag) return
  window.gtag('event', 'page_view', { page_path: path })
}
